function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import React from "react";
export default (({
  styles = {},
  ...props
}) => /*#__PURE__*/React.createElement("svg", _extends({
  width: "32",
  height: "32",
  xmlns: "http://www.w3.org/2000/svg"
}, props), /*#__PURE__*/React.createElement("g", {
  fillRule: "nonzero",
  fill: "none"
}, /*#__PURE__*/React.createElement("circle", {
  stroke: "#DADCDF",
  cx: "16",
  cy: "16",
  r: "15.5"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#9B9B9B",
  cx: "8.5",
  cy: "16.5",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#9B9B9B",
  cx: "15.5",
  cy: "16.5",
  r: "1"
}), /*#__PURE__*/React.createElement("circle", {
  stroke: "#9B9B9B",
  cx: "22.5",
  cy: "16.5",
  r: "1"
}))));